export const alpha_num = (v, err) => {
  if(!v) return false
  if(v.search(/^[a-z\d\s]+$/i) >= 0) return true
  return err || 'Only alpha numberic characters are valid'
}

export const constrain_length = (min, max, err) => {
  return (v) => {
    if(!v || !v.length) return false
    if(v.length >= min && v.length <= max) return true
    return err || `Value must have length between ${min} and ${max} characters`
  }
}

export const has_value = (v, err) => {
  if(v !== '' && v !== null && v !== undefined) return true
  return err || 'Value must be defined'
}
